import { useEffect } from "react";
import { useMaxView, useViewport } from "src/contexts";
import { IconButton, Map, MapProps } from "~components";
import { Css } from "~generated/css";

/**
 * Wrapper around Map component that handles its own expand functionality for mobile.
 */
export function ConfiguratorMap(props: MapProps) {
  const { center, markers, ...rest } = props;
  const { isMaxViewOpen, openMaxViewModal } = useMaxView();
  const { isMobile } = useViewport();

  const mapContent = (
    <div css={Css.w100.h100.$}>
      <Map center={center} markers={markers} {...rest} />
    </div>
  );

  // Update modal content state when center/markers change while modal is open
  useEffect(() => {
    if (isMaxViewOpen) {
      openMaxViewModal(mapContent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [markers, center]);

  return (
    <>
      {isMobile && (
        <div css={Css.absolute.top2.right8.z2.$}>
          <IconButton
            icon="expand-small"
            color="primary"
            size="medium"
            shape="square"
            onClick={() => openMaxViewModal(mapContent)}
          />
        </div>
      )}
      {mapContent}
    </>
  );
}
